import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "OprHistoryStatistics" }
const _hoisted_2 = {
  class: "itemModal",
  style: {"position":"fixed","z-index":"10"}
}

import {searchFormConfig} from './config/search.config'
import {contentTableConfig} from './config/content.config'
import {rankingTableConfig} from './config/ranking.config'
import {usePageSearch} from '@/hooks/userPageSearch'
import {usePageModal} from '@/hooks/usePageModal'
import dayjs from "dayjs";
import {useStore} from "@/store";
import {getListData, getPageListData} from "@/service/main/system";
import localCache from "@/utils/cache";
import {ref} from "vue";
import LfTable from '@/components/LfTable.vue'
import {ElLoading} from "element-plus";


export default /*#__PURE__*/_defineComponent({
  __name: 'OprHistoryStatistics',
  setup(__props) {

const store = useStore()

const getEmp = async () => {
  let userList = localCache.getCache('empData')
  const userOptions = userList.map((item: any) => {
    return {title: item.realName, value: item.id};
  })
  const userItem = searchFormConfig.formItems.find((item) => item.field === 'userid')
  userItem!.options = userOptions;
}
getEmp()

const getMenu = async () => {
  let menuList = await getListData('/main/oprHistory/queryMenu', {})
  const menuOptions = menuList.map((item: any) => {
    return {title: item, value: item};
  })
  const menuItem = searchFormConfig.formItems.find((item) => item.field === 'menu')
  menuItem!.options = menuOptions;
}
getMenu()

const getModule = async () => {
  let moduleList = await getListData('/main/oprHistory/queryModule', {menu: '首页'})
  const moduleOptions = moduleList.map((item: any) => {
    return {title: item, value: item};
  })
  const moduleItem = searchFormConfig.formItems.find((item) => item.field === 'module')
  moduleItem!.options = moduleOptions;
}
getModule()

const queryParam = {
  timeSlot: [
    dayjs().subtract(1, 'months').startOf('date').format('YYYY-MM-DD'),
    dayjs().endOf('date').format('YYYY-MM-DD')
  ],
  menu: '首页'
}
store.commit('system/changeQueyryInfo', queryParam)

const handleSortChange = (value: any) => {
  store.commit('system/changeOrderInfo', {
    orderBy: value.prop,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

const rankingData = ref([])
const dialogTitle = ref('')
const dialogVisible = ref(false)
const dataCount = ref(0)
const handleActivityRanking = () => {
  dialogVisible.value = true
  console.log('活跃用户排行')
  dialogTitle.value = "活跃用户排行"
  getRankingData(0)
}

const handleHotRanking = () => {
  dialogVisible.value = true
  console.log('热门功能排行')
  dialogTitle.value = "热门功能排行"
  getRankingData(1)
}

const getRankingData = async (type: number) => {
  rankingData.value = []
  const loadingInstance = ElLoading.service({
    lock: true,
    text: '数据统计中...',
    background: 'rgba(0, 0, 0, 0.7)'
  });
  await getPageListData('/main/oprHistoryStatistics/ranking',{
      type: type,
      startTime: store.state.system.queryInfo.timeSlot[0],
      endTime: store.state.system.queryInfo.timeSlot[1]}
  ).then((res) => {
    loadingInstance.close()
    rankingData.value = res
    dataCount.value = res.length
  })
}

const dialogClose = ()=> {
  rankingData.value = [];
}

const resetCb = () => {
  return queryParam
}

const searchCb = () => {
  return queryParam
}

const [pageModalRef, defaultInfo, handleNewData, handleEditData] = usePageModal()
const [pageContentRef, handleResetClick, handleSearchClick] = usePageSearch(searchCb, resetCb)

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageContent = _resolveComponent("PageContent")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_PageSearch, {
        searchFormConfig: _unref(searchFormConfig),
        onResetBtnClick: _unref(handleResetClick),
        onSearchBtnClick: _unref(handleSearchClick)
      }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
      _createVNode(_component_PageContent, {
        ref_key: "pageContentRef",
        ref: pageContentRef,
        contentTableConfig: _unref(contentTableConfig),
        pageName: "oprHistoryStatistics",
        onSortChange: handleSortChange,
        onActivityRankingClick: handleActivityRanking,
        onHotRankingClick: handleHotRanking
      }, null, 8, ["contentTableConfig"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_dialog, {
        modelValue: dialogVisible.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dialogVisible).value = $event)),
        width: "50%",
        center: "",
        "destroy-on-close": "",
        onClosed: dialogClose
      }, {
        default: _withCtx(() => [
          _createVNode(LfTable, _mergeProps({
            title: dialogTitle.value,
            listData: rankingData.value,
            listCount: dataCount.value
          }, _unref(rankingTableConfig)), null, 16, ["title", "listData", "listCount"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ], 64))
}
}

})